document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia('(max-width: 1199px)').matches) return; // Only on desktop

    const initHoverBehavior = (section) => {
        const tracks = section.querySelectorAll('[data-js-carousel="track"]');
        
        tracks.forEach(track => {
            const listItems = Array.from(track.children);
            const container = track.closest('[role="tabpanel"]') || section;
            const images = container.querySelectorAll('[data-js-carousel="img"]');

            listItems.forEach((item, index) => {
                const link = item.querySelector('.list__link') || item.querySelector('a');
                if (!link || link.getAttribute('role') === 'tab' || link.closest('[role="tablist"]')) return;

                item.addEventListener('mouseenter', () => {
                    // Remove active from all links
                    listItems.forEach(li => {
                        const link = li.querySelector('.list__link') || li.querySelector('a');
                        if (link) link.removeAttribute('aria-current');
                    });

                    if (images.length > 1) {
                        images.forEach(img => img.setAttribute('aria-hidden', 'true'));
                    }

                    // Set active to current link
                    const currentLink = item.querySelector('.list__link') || item.querySelector('a');
                    if (currentLink) currentLink.setAttribute('aria-current', 'page');

                    // Show corresponding image
                    if (images.length > 1) {
                        const targetImg = container.querySelector(`[data-js-carousel="img"][data-index="${index}"]`);
                        if (targetImg) {
                            targetImg.setAttribute('aria-hidden', 'false');
                        }
                    }
                });
            });
        });
    };

    const carouselSections = document.querySelectorAll('[data-js="carousel"]');
    carouselSections.forEach(initHoverBehavior);
});
